import React from "react";
import "../../styles/AboutUsBanner.css";
import myvideo from '../../assets/horecaaboutus.mp4'

const HerocaAboutUsBanner = () => {
  return (
    <section className="about-us-banner">
      <video
        className="aboutus-banner-video"
        src={myvideo}
        autoPlay
        loop
        muted
      ></video>
      <div className="aboutus-overlay">
        <div className="aboutus-content">
          <h1>Crafting Excellence in Hospitality Supplies</h1>
          <p>Delivering quality, integrity, and innovation to the hospitality industry since 2022.</p>
        </div>
      </div>
    </section>
  );
};

export default HerocaAboutUsBanner;
